import { render, staticRenderFns } from "./alarmConsult.vue?vue&type=template&id=3613b0a8&scoped=true"
import script from "./alarmConsult.vue?vue&type=script&lang=js"
export * from "./alarmConsult.vue?vue&type=script&lang=js"
import style0 from "./alarmConsult.vue?vue&type=style&index=0&id=3613b0a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3613b0a8",
  null
  
)

export default component.exports